import { Component, computed, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UserAvatarComponent } from '@modules/user/components/user-avatar/user-avatar.component';
import { UserService } from '@services/user.service';
import { NavigationService } from '@services/navigation.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-user-profile-info',
    imports: [TranslatePipe, UserAvatarComponent, RouterLink],
    template: `
        <div class="menu-section">
            <div class="section-content">
                <div class="flex flex-row align-items-center justify-content-start gap-3">
                    <app-user-avatar></app-user-avatar>
                    <div class=" flex flex-column gap-1">
                        <span class="font-semibold text-xl">
                            {{ userName() }}
                        </span>
                        <span class="block epx-color-grey-600">
                            {{ user().email }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="section-footer mt-3">
                <a class="flex-row flex  gap-1 link-secondary font-semibold" [routerLink]="['/profile']">
                    <span>{{ 'MODULE_USER.GENERAL.PROFILE_AND_SETTING' | translate }}</span>
                </a>
            </div>
        </div>
    `
})
export class UserProfileInfoComponent {
    translate = inject(TranslateService);
    userService = inject(UserService);
    navigation = inject(NavigationService);
    user = this.userService.user;
    userName = computed(() => {
        const u = this.user();
        return [u.firstname, u.lastname].filter(Boolean).join(' ') || '';
    });
}
